<template>
  <div class="slides clearfix">
    <div class="page-shadow">
      <div class="container">
        <div class="heading">
          <h2>{{$t('areaProducts.headerTopTextPresentation')}}</h2>
          <p>{{$t('areaProducts.headerTopSubTextPresentation')}}</p>
        </div>
        <div class="right-box" :class="{'show': showText}">
          <div class="vertical-middle">
            <div class="right-box-content">
              <div class="number" id="bigNumber" :class="'current-' + currentStep">
                <div class="numbers">
                  <span v-for=" i in steps.length">{{i}}</span>
                </div>
              </div>
              <div class="text-content">
                <h3>{{steps[currentStep !== 0 ? currentStep - 1 : currentStep].title}}</h3>
                <p id="content" v-html="steps[currentStep !== 0 ? currentStep - 1 : currentStep].text"></p>
                <div class="btn-hover">
                  <a @click="nextStep" :class="{'visible': currentStep !== steps.length}" id="playButton"
                     class="btn orange next-step">{{$t('steps.next')}}<span></span></a>
                </div>
                <div class="last-step" :class="{'visible': currentStep === steps.length}">
                  <div class="btn-hover">
                    <div class="btn orange" @click="showModal">{{$t('steps.ask')}}</div>
                  </div>
                  <div class="btn-hover">
                    <router-link to="/products/area" class="btn red-border">{{$t('steps.learnMore')}}<span/>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterOrange/>
      </div>
    </div>
  </div>
</template>

<script>
  import FooterOrange from '../components/FooterOrange';
  import store from '../store/store';

  window.store = store;
  export default {
    name: 'area-presentation',
    data() {
      window.t = this;
      return {
        nextBtn: null,
        showText: false,
        currentStep: 0,
        isNextBtn: false,
      }
    },
    computed: {
      steps: function () {
        return this.$t('areaPresentation.steps')
      }
    },
    methods: {
      showModal: function () {
        store.commit('SET_MODAL', {visible: true, questionName: 'area'});
      },
      showNextBtn: function () {
        this.showText = true
        this.currentStep++;
        // this.isNextBtn = true;
      },
      nextStep: function () {
        alert('awd')
        this.showText = false
        // this.isNextBtn = false;
        store.commit('PLAY_NEXT');
      }
    },
    mounted: function () {
      store.commit('SHOW_CANVAS');

      this.nextBtn = document.querySelector('#playButton');
      store.commit('PLAY_FOREST_PRESENTATION', this.showNextBtn)
    },
    destroyed() {
      store.commit('CLEAR_GROUND');
      store.commit('HIDE_CANVAS');
      store.commit('HOME_ANIM_FINISHED')

    },
    components: {
      FooterOrange
    }
  }
</script>



// WEBPACK FOOTER //
// AreaPresentation.vue?3d8f11ad